export default {
    blackList_00001: "Schwarze Liste",
    blackList_00002: "Bitte geben Sie den Spitznamen oder die Handynummer des Benutzers ein",
    blackList_00003: "Nach der Aufnahme in die schwarze Liste können das Mikrosignal des Nutzers, seine Handynummer und andere Mikrosignale, die derselben Handynummer entsprechen, am Standort nicht mehr aufgeladen werden",
    blackList_00004: "Gründe", 
    blackList_00005: "Bitte geben Sie den Grund für die Aufnahme des Benutzers in die Sperrliste an, maximal 20 Zeichen",
}